<template>
	<ul
		class="app-pagination"
		:class="{'app-pagination--disabled' : $attrs.disabled }"
	>
		<li
			class="app-pagination__page"
			:class="{'app-pagination__page--disabled' : Number(value) === 1}"
			@click="$emit('change', Number(value) - 1)"
		>
			<div class="app-pagination__arrow app-pagination__arrow--left"></div>
		</li>
		<li
			v-for="(page, index) in pagination"
			:key="index"
			:class="{
					'app-pagination__page--disabled' : page === '...',
					'app-pagination__page--active' :page === Number(value)
				}"
			class="app-pagination__page"
			@click.stop="$emit('change', page)"
		>
			{{ page }}
		</li>
		<li
			class="app-pagination__page"
			:class="{'app-pagination__page--disabled' : Number(value) === total}"
			@click="$emit('change', Number(value) + 1)"
		>
			<div class="app-pagination__arrow app-pagination__arrow--right"></div>
		</li>
	</ul>
</template>

<script>
export default {
	props: {
		value: [Number, String],
		total: [Number, String]
	},

	model: {
		prop: 'value',
		event: 'change'
	},

	computed: {
		pagination () {
			const current = Number(this.value || 1)
			const total = Number(this.total || 1)
			const delta = 2
			const start = Math.max(2, current - delta)
			const end = Math.min(total - 1, current + delta)

			let range = []
			for (let i = start; i <= end; i++) {
				range.push(i)
			}

			if (current - delta > 2) {
				range.unshift('...')
			}
			if (current + delta < total - 1) {
				range.push('...')
			}

			range.unshift(1)
			if (total > 1) {
				range.push(total)
			}

			return range
		}
	}
}
</script>

<style lang="scss" scoped>
.app-pagination {
	display: inline-flex;
	list-style: none;
	border: .5px solid $default-light;
	border-radius: 3px;

	&--disabled {
		pointer-events: none;
		opacity: 0.5;
	}

	&__page {
		padding: 5px;
		min-width: 2em;
		text-align: center;
		color: $primary;
		border: .5px solid $default-light;
		display: flex;
		align-items: center;
		justify-content: center;
		cursor: pointer;

		&:hover {
			background-color: $primary-light;
			color: $primary;
		}

		&--active {
			background-color: $primary;
			color: #fff;
			pointer-events: none;
		}

		&--disabled {
			pointer-events: none;
		}
	}

	&__arrow {
		width: .5em;
		height: .5em;
		border: solid $primary;
		border-width: .1em .1em 0 0;
		pointer-events: none;

		&--left {
			transform: rotate(-135deg);
		}

		&--right {
			transform: rotate(45deg);
		}
	}
}
</style>
